import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge, validators } from 'tailwind-merge'

// Without this, numeric font-size tokens (`text-11`) are read as text colors and
// dropped whenever they are merged with one.
const twMerge = extendTailwindMerge({
  extend: { theme: { text: [validators.isInteger] } }
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
